import { Flex, Skeleton } from "@scaleaq/sui-react";
import { Loading } from "../loading/Loading";
import { LoadingGhostParts } from ".";

export namespace LoadingGhost {
    export type Props = Flex.Row.Props & {
        skeleton?: Skeleton.Props;
        loading?: Loading.Props;
    }
}

export const LoadingGhost = (props: LoadingGhost.Props) => {
    const { className, alignment = "center", skeleton, loading, ...restProps } = props;
    const { width = "100%", height = "3rem", variant = "soft", color = "action" } = skeleton ?? {};
    const { size = "small", className: loadingClassName, ...loadingRestProps } = loading ?? {};

    return(
        <LoadingGhostParts.Root {...restProps}>
            <LoadingGhostParts.Skeleton width={width} height={height} variant={variant} color={color} />
            <LoadingGhostParts.Loading size={size} className={loadingClassName} {...loadingRestProps} />
        </LoadingGhostParts.Root>
    );
}